import { isEmpty } from "underscore";

export class CentralStation {

	public BUID: number = 0;
	public NetID: number = 0;
	public CSID: number = 0;
	public NetIDc: string = "";
	public CSIDc: string = "";
	public CentralStationName: string = "";
	public Active: boolean = false;
    public IsAssociatedWithGroup: boolean = false;
    public DropDownText: string = "";

	public CityCsText: string = "";

	public IsVisible: boolean = true;

	constructor(cststat: CentralStation) {
		this.CentralStationName = cststat.CentralStationName || "";
		this.BUID = cststat.BUID || 0;
		this.NetID = cststat.NetID || 0;
		this.CSID = cststat.CSID || 0;
		this.Active = cststat.Active || false;
		this.IsAssociatedWithGroup = cststat.IsAssociatedWithGroup || false;
		this.NetIDc = cststat.NetIDc || "";
		this.CSIDc = cststat.CSIDc || "";

		//Custom Property
		if (!isEmpty(this.NetIDc) && !isEmpty(this.CSIDc))
            this.CityCsText = this.NetIDc + "-" + this.CSIDc;

        if (!isEmpty(this.CityCsText) && !isEmpty(this.CentralStationName))
            this.DropDownText = this.CityCsText + " " + this.CentralStationName;
	}
}
